import React from 'react';
import Container from 'Nori/Container';
import styles from 'Custom/Table/ConditionsTable.module.scss';
import RichText from 'Custom/RichText';

import ConditionIcon from 'Images/brand-icons/condition-icon.svg';

const TABLE_VARIANTS = {
  simple: styles.simple,
  default: '',
};

const ConditionsTable = ({
  className = '',
  variant = '',
  content = [],
  showIcon = true,
  footnote = null,
  children,
  ...props
}) => {
  const variantClassName = TABLE_VARIANTS[variant] || TABLE_VARIANTS.default;
  const containerSize = variant === TABLE_VARIANTS.default ? 'md' : '';

  return (
    <section
      data-qa-tag="conditions-table-section"
      className={`${styles.conditionsTable} ${variantClassName} ${className}`}
      {...props}
    >
      <Container data-qa-tag="conditions-table-container" size={containerSize} className={styles.conditionsCopy}>
        {children}
      </Container>
      <Container>
        <div data-qa-tag="conditions-table-wrapper" className={styles.tableWrapper}>
          {content.map((cell, index) => (
            <div key={`cell-${index}`} className={styles.tableCell} data-qa-tag="conditions-table-cell">
              {showIcon && <ConditionIcon data-qa-tag="conditions-table-icon" />}
              <h4 data-qa-tag="conditions-table-title" className={styles.tableCellTitle}>{cell}</h4>
            </div>
          ))}
        </div>
      </Container>
      {footnote && (
        <Container data-qa-tag="conditions-table-footnote" size="md" className={styles.conditionsFootnote}>
          <RichText data-qa-tag="conditions-table-content-wrapper">{footnote}</RichText>
        </Container>
      )}
    </section>
  );
};

export default ConditionsTable;
